import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { jarvisPrimeInvestMoreActions } from "stores/jarvisPrime/jarvisPrimeInvestMore/jarvisPrimeInvestMoreActions";
import { masterActions } from "stores/master/masterActions";

const mapStateToProps = (state) => {
    return {
        minInvestmentAmount: state.jarvisPrime.primeOnboarding.minimumAdditionalInvestAmount,
        investmentStocksData: state.jarvisPrime.PrimeInvestMore.investmentStocks,
        isInvestmentStocksLoading: state.jarvisPrime.PrimeInvestMore.loading.investmentStocks,
        profileData: state.customer.profile,

        brokersList: state.common.brokers,
        isBrokersListLoading: state.common.loading.brokers,
        isBrokersListInitialCalled: state.common.initialCalled.brokers,
        centrumReferalURL: state.common.featureConfig.centrumReferalURL
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getInvestmentStocksAction: jarvisPrimeInvestMoreActions.getInvestmentStocks,
            getBrokersAction: commonActions.getBrokers,
            pendingCallAction: masterActions.getPendingCall,
        },
        dispatch
    );

const PrimeInvestMoreStore = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);
export default PrimeInvestMoreStore;
